import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useIsFeatureEnabled } from "../../_app/featureFlags";
import { TaxAdvisoryDetails } from "../../taxAdvisors/TaxAdvisoryDetails";

export const Route = createFileRoute("/steuerberatungen/$taxAdvisoryId")({
  loader: ({ context: { queryClient, trpc }, params: { taxAdvisoryId } }) => {
    void queryClient.ensureQueryData(
      trpc.taxAdvisories.getTaxAdvisory.queryOptions({ taxAdvisoryId })
    );
    void queryClient.ensureQueryData(
      trpc.taxAdvisories.listTaxAdvisoryMembers.queryOptions({ taxAdvisoryId })
    );
    void queryClient.ensureQueryData(
      trpc.taxAdvisories.listUsersNotInAnyTaxAdvisory.queryOptions()
    );
  },
  component: TaxAdvisoryDetailsRoute,
});

function TaxAdvisoryDetailsRoute() {
  const { taxAdvisoryId } = Route.useParams();
  const isManageTaxAdvisorsEnabled = useIsFeatureEnabled("manageTaxAdvisors");

  if (!isManageTaxAdvisorsEnabled) {
    return <Navigate to="/" />;
  }

  return <TaxAdvisoryDetails taxAdvisoryId={taxAdvisoryId} />;
}
